import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DeviceType, injectable} from '@gongxigames/framework/core';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad/KeypadView';

@injectable()
export class KeypadViewMobileLandscape extends KeypadView {
    public static readonly NAME: symbol = Symbol('KeypadViewMobileLandscape');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    public init(): void {
        this.initMainSprite();
    }
}
